<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="row" v-if="order">
        <div class="col-lg-8">
          <div class="card no-shadow">
            <div class="card-body">
              <SeatMap2 :order="order" @change-selected="changeSelected"></SeatMap2>
            </div>
          </div>
        </div>
        <div class="col-lg-4 d-print-none">
          <div class="card">
            <div class="card-body">
              <div class="mb-3">
              <h4>{{order.company}}</h4>
              {{order.firstname}} {{order.name}}<br />
              Kontingent: {{order.capacity}} <br />
              Gebucht: {{order.amount}} <br />
              <template v-if="order.tickets">Tickets: {{order.tickets.length}}</template><br />
              </div>
              <b-button
                  class="btn btn-warning w-md waves-effect waves-light" @click="saveTickets"
              >Tickets speichern</b-button
              > <b-button
                class="btn btn-danger w-md waves-effect waves-light" @click="saveAndShipTickets"
            >Speichern & Verschicken</b-button
            > <b-button
                class="btn btn-success w-md waves-effect waves-light" @click="editOrder"
            >Editieren</b-button
            >
            </div>
          </div>
        </div>
      </div>
  </Layout>
</template>

<script>
import Repository from "@/repositories/RepositoryFactory";
const OrderRepository = Repository.get("orders");


import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import SeatMap2 from "@/components/Seatmap2";
import Swal from "sweetalert2";
/**
 * Ticket Orders Component
 */
export default {
  page: {
    title: "Ticket Orders",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    SeatMap2,
    Layout,
    PageHeader,
  },
  props: ['id'],
  data() {
    return {
      title: "Ticket Order",
      items: [
        {
          text: "Ticket Orders",
          href: "/orders",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      order: null,
      selected: [],
    };
  },
  computed: {

  },
  created() {
    this.getOrder();
  },
  mounted() {

  },
  methods: {
    changeSelected(s){
      this.$log.debug(s);
      this.selected = s;
    },
    saveTickets: async function(){
      OrderRepository.saveTickets(this.selected, this.id).then(() => {
        this.$router.push({ name: "orders"});
      }).catch((err)=>{
        Swal.fire("Error", err, "error");
      });
    },
    saveAndShipTickets: async function(){
      OrderRepository.saveTickets(this.selected, this.id).then(() => {
        this.$router.push({ name: "orders-shipping-id", params: {id: this.id}});
      }).catch((err)=>{
        Swal.fire("Error", err, "error");
      });
    },
    editOrder(){
      this.$router.push({name: "orders-id", params: {id: this.order.id}})
    },

    getOrder: async function() {
      const { data } = await OrderRepository.get(this.id);
      this.order = data;
    },
  },
};
</script>
<style lang="scss">
.card.no-shadow{
  box-shadow: none;
}
</style>